import QuestionOwnershipTerms from "consts/QuestionOwnershipTerms";

const QuestionOwnershipOptions = [
  { text: "Syndicated", value: QuestionOwnershipTerms.SYNDICATED },
  { text: "Custom", value: QuestionOwnershipTerms.CUSTOM },
  { text: "CivicScience", value: QuestionOwnershipTerms.CIVICSCIENCE },
];

export default QuestionOwnershipOptions;
